module.exports = __webpack_public_path__ + "Roboto-Bold.ad140ff02a7091257e2b.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Bold.woff
// module id = 127
// module chunks = 16